import React from 'react';
import { Text, View, Pressable } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

type Props = {
  message: string;
  onContinue: () => void;
};

export function AccountDeletionAckScreen({ message, onContinue }: Props) {
  const insets = useSafeAreaInsets();
  return (
    <View
      className="flex-1 bg-white px-6 dark:bg-black"
      style={{ paddingTop: insets.top + 24, paddingBottom: insets.bottom + 24 }}>
      <Text className="text-center text-xl font-bold text-zinc-900 dark:text-zinc-50">
        Üyeliğiniz kapatıldı
      </Text>
      <Text className="mt-4 text-center text-base leading-6 text-zinc-600 dark:text-zinc-400">
        {message}
      </Text>
      <Pressable
        onPress={onContinue}
        className="mt-10 rounded-xl bg-zinc-900 py-3.5 active:opacity-90 dark:bg-zinc-50">
        <Text className="text-center text-base font-semibold text-white dark:text-zinc-950">
          Tamam
        </Text>
      </Pressable>
    </View>
  );
}
